import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { X, Copy, Check, Tag } from 'lucide-react';
import { popupBannerAPI, IMAGE_BASE } from '../services/api';

export default function PopupBanner() {
    const [banner, setBanner] = useState(null);
    const [visible, setVisible] = useState(false);
    const [copied, setCopied] = useState(false);
    const [closing, setClosing] = useState(false);

    useEffect(() => {
        const dismissed = sessionStorage.getItem('atolyekirpi_popup_dismissed');
        if (dismissed) return;

        popupBannerAPI.get()
            .then(res => {
                const data = res.data;
                if (!data || !data.isActive) return;
                const delay = (data.delaySeconds || 1) * 1000;
                setTimeout(() => {
                    setBanner(data);
                    setVisible(true);
                }, delay);
            })
            .catch(() => {});
    }, []);

    const handleClose = useCallback(() => {
        setClosing(true);
        setTimeout(() => {
            setVisible(false);
            setBanner(null);
            sessionStorage.setItem('atolyekirpi_popup_dismissed', '1');
        }, 300);
    }, []);

    const handleCopy = () => {
        if (!banner?.couponCode) return;
        navigator.clipboard.writeText(banner.couponCode).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    // Close on ESC
    useEffect(() => {
        if (!visible) return;
        const handler = (e) => { if (e.key === 'Escape') handleClose(); };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [visible, handleClose]);

    if (!visible || !banner) return null;

    const imgSrc = banner.image ? (banner.image.startsWith('http') ? banner.image : IMAGE_BASE + banner.image) : null;

    return (
        <div className={`popup-overlay ${closing ? 'popup-closing' : ''}`} onClick={handleClose}>
            <div className={`popup-modal ${closing ? 'popup-modal-closing' : ''}`} onClick={e => e.stopPropagation()}>
                <button className="popup-close" onClick={handleClose} aria-label="Kapat">
                    <X size={20} />
                </button>

                {imgSrc && (
                    <div className="popup-image">
                        <img src={imgSrc} alt={banner.title} />
                    </div>
                )}

                <div className="popup-content">
                    <h2 className="popup-title">{banner.title}</h2>

                    {banner.description && (
                        <p className="popup-desc">{banner.description}</p>
                    )}

                    {banner.couponCode && (
                        <div className="popup-coupon">
                            {banner.couponDescription && (
                                <span className="popup-coupon-label">
                                    <Tag size={13} /> {banner.couponDescription}
                                </span>
                            )}
                            <div className="popup-coupon-box" onClick={handleCopy}>
                                <span className="popup-coupon-code">{banner.couponCode}</span>
                                <button className="popup-coupon-copy">
                                    {copied ? <><Check size={14} /> Kopyalandı</> : <><Copy size={14} /> Kopyala</>}
                                </button>
                            </div>
                        </div>
                    )}

                    <Link to={banner.buttonLink || '/urunler'} className="popup-cta" onClick={handleClose}>
                        {banner.buttonText || 'Alışverişe Başla'}
                    </Link>
                </div>
            </div>
        </div>
    );
}
